var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgChevronDownCircle = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#004F71"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.31408 9.26652C6.113 9.43675 6 9.66787 6 9.90888C6 10.1499 6.113 10.381 6.31408 10.5513L11.2429 14.7335C11.6617 15.0888 12.3382 15.0888 12.757 14.7335L17.6859 10.5513C18.1047 10.1959 18.1047 9.62187 17.6859 9.26651C17.2671 8.91116 16.5906 8.91116 16.1718 9.26651L11.9946 12.8018L7.82817 9.26652C7.40938 8.91116 6.72213 8.92027 6.31408 9.26652Z",
  fill: "white"
})));
export default SvgChevronDownCircle;